/**
 * Vue Router 路由配置
 * 替代原来的多页面HTML结构
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入页面组件
import HomePage from '@/views/HomePage.vue'
import AboutPage from '@/views/AboutPage.vue'
import ExplorePage from '@/views/ExplorePage.vue'
import HeritagePage from '@/views/HeritagePage.vue'
import ProfilePage from '@/views/ProfilePage.vue'
import LongzhouPage from '@/views/LongzhouPage.vue'
import LongzhouTeachingPage from '@/views/LongzhouTeachingPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      title: '中华非遗 - 传承千年文化瑰宝'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
    meta: {
      title: '认识非遗 - 中华非遗',
      theme: 'theme-about'
    }
  },
  {
    path: '/explore',
    name: 'Explore',
    component: ExplorePage,
    meta: {
      title: '走近非遗 - 中华非遗',
      theme: 'theme-explore'
    }
  },
  {
    path: '/heritage',
    name: 'Heritage',
    component: HeritagePage,
    meta: {
      title: '传习非遗 - 中华非遗',
      theme: 'theme-heritage'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
    meta: {
      title: '个人中心 - 中华非遗',
      requiresAuth: true
    }
  },
  {
    path: '/longzhou',
    name: 'Longzhou',
    component: LongzhouPage,
    meta: {
      title: '龙舟 - 中华非遗',
      theme: 'theme-heritage'
    }
  },
  {
    path: '/longzhou-teaching',
    name: 'LongzhouTeaching',
    component: LongzhouTeachingPage,
    meta: {
      title: '龙舟教学 - 中华非遗',
      theme: 'theme-heritage'
    }
  }
]

const router = new VueRouter({
  mode: 'hash', // 使用hash模式便于部署
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // 设置页面主题类
  document.body.className = ''
  if (to.meta.theme) {
    document.body.classList.add(to.meta.theme)
  }
  
  next()
})

export default router 